module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_search_gold-3a4c3d8295127bb2b82fdda5183f48bd.svg";